import { render, staticRenderFns } from "./NewSocialWorker.vue?vue&type=template&id=efe14e4c&scoped=true"
import script from "./NewSocialWorker.vue?vue&type=script&lang=js"
export * from "./NewSocialWorker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe14e4c",
  null
  
)

export default component.exports